// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Gj-7","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Lpuv"};